import { Component, StrictMode, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles.css'

/**
 * A rendering error shows a message and a way back instead of a blank page.
 * Nothing in the Sheet depends on the page, so reloading loses nothing saved.
 */
class Crashed extends Component<{ children: ReactNode }, { error?: Error }> {
  state: { error?: Error } = {}
  static getDerivedStateFromError(error: Error) {
    return { error }
  }
  render() {
    if (!this.state.error) return this.props.children
    return (
      <main>
        <section className="section">
          <h2>Something went wrong on this page</h2>
          <p>Everything already saved is safe in your spreadsheet. Reloading will bring the page back.</p>
          <p className="error">✕ {this.state.error.message}</p>
          <button onClick={() => location.reload()}>Reload</button>
        </section>
      </main>
    )
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Crashed>
      <App />
    </Crashed>
  </StrictMode>,
)
